export default "__VITE_ASSET__BIGh$RGI__"